import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  tooltipWrapper: {
    lineHeight: '1.5rem',
    display: 'flex',
    alignItems: 'center'
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  helperTextRoot: { marginLeft: 0, marginTop: 0, fontSize: theme.spacing(2) },
  cardActionsRot: {
    padding: '48px 16px 24px'
  },
  buttonRoot: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  icon: {
    color: theme.palette.error.main,
    marginRight: theme.spacing(1)
  },
  buttonLabel: {
    textTransform: 'initial',
    color: theme.palette.error.main,
    fontSize: '20px'
  },
  ivalidInputLabel: {
    color: theme.palette.danger
  },
  inputLabel: {
    marginBottom: theme.spacing(0.75),
    fontSize: theme.spacing(2)
  }
}));
